/**
 * @format
 * @Categoryat
 */

import { useContext, useEffect, useState } from 'react';

import { Link, useLocation, useParams } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Master from '../Layouts/Master';

const City = () => {
  const eventContext = useContext(EventContext);
  const { provinceId } = useParams();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [CategoryRemoveId, setCategoryRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getCities();
  }, [search, provinceId]);
  const getCities = async () => {
    setLoading(true);
    await useApi.get(
      `/city/${provinceId}${search}`,
      {},
      (res) => {
        eventContext.cities = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const removeCategory = async (categoryId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/general/city/${categoryId}`,
      {},
      (res) => {
        success('شهر مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getCities();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست شهر ها
          </h1>
        </div>
        <Link
          to={`/panel/city/create/${provinceId}`}
          className='d-flex flex-row btn btn-outline-info '
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>ایجاد شهر</span>
        </Link>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.cities?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.cities?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.name}</td>

                  <td>
                    <div className='d-flex flex-row'>
                      <Link to={`/panel/city/edit/${item.id}`} className='mx-2'>
                        ویرایش
                      </Link>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setCategoryRemoveId(item.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد شهر بر روی منوی ایجاد شهر کلیک کنید
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          search={search}
          totalPage={eventContext.cities?.meta?.pagination?.total_pages}
          basePath={`/panel/city`}
        />
      </div>
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف شهر مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeCategory(CategoryRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default City;
